import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, RouterModule]
})
export class AppComponent implements OnInit {
  public appPages = [
    { title: 'Accueil', url: '/home', icon: 'home' },
    { title: 'Ingestion CV', url: '/ingestion', icon: 'cloud-upload' },
    { title: 'Recherche CV', url: '/chat', icon: 'search' },
    { title: 'Administration', url: '/admin', icon: 'people' },
    { title: 'Mon Profil', url: '/profile', icon: 'person' }
  ];

  showMenu = true;
  currentUser: any = null;
  isAdmin = false;

  constructor(private router: Router) {}

  ngOnInit() {
    // Cacher le menu sur la page login
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.showMenu = !event.url.includes('/login');
      this.loadCurrentUser();
    });

    // Charger l'utilisateur au démarrage
    this.loadCurrentUser();
  }

  loadCurrentUser() {
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      this.currentUser = JSON.parse(userStr);
      this.isAdmin = this.currentUser?.role === 'admin' || false;
    }
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.currentUser = null;
    this.isAdmin = false;
    this.router.navigate(['/login']);
  }
}
